import React from "react";
import PropTypes from "prop-types";
import { convertUnit } from "~/assets/js/Format";
import i18n from "~/assets/js/Helpers/i18n";
import { formatCalculatedEnergy, getTotalEnergy } from "../../Helpers/util";

const ClimateDetails = ({
    climateDetails,
    itemQuantity = 1,
    isSimple = false,
}) => {
    const { iconPath } = reactConfig;

    const handleUnitConversion = (value) => {
        const multiplier = 0.001; // factor for g -> kg && ml -> l
        if (itemQuantity <= 0) {
            return convertUnit(value, multiplier);
        }
        return convertUnit(value * itemQuantity, multiplier);
    };

    const shouldDisplay = (value) => {
        const badValues = [0, "0", "", null, undefined];
        return !badValues.includes(value);
    };

    const handleEnergy = () => {
        if (!("weight" in climateDetails)) {
            return Math.round((climateDetails.energy * itemQuantity) / 1000);
        }

        const formatEnergy = {
            details: { ...climateDetails },
        };

        const quantity = itemQuantity <= 0 ? 1 : itemQuantity;

        return Math.round(quantity * getTotalEnergy(formatEnergy));
    };

    const dot = <>&nbsp;&#8226;&nbsp;</>;

    return (
        <div className={`climate-details ${isSimple ? "simple" : ""}`}>
            {(shouldDisplay(climateDetails.energy) ||
                shouldDisplay(climateDetails.calculated_energy)) && (
                <span className="climate-details__calories">
                    <img
                        src={`${iconPath}/cutlery-new.svg`}
                        alt="cutlery icon"
                    />
                    {shouldDisplay(climateDetails.energy) && (
                        <>{handleEnergy()}</>
                    )}
                    {shouldDisplay(climateDetails.calculated_energy) && (
                        <>
                            {formatCalculatedEnergy(
                                climateDetails.calculated_energy
                            )}
                        </>
                    )}
                    {i18n.t("cart.cartItem.kcal")}
                    {isSimple && dot}
                </span>
            )}
            {shouldDisplay(climateDetails.co2) && (
                <span className="climate-details__emission">
                    <img src={`${iconPath}/globe.svg`} alt="globe icon" />
                    {handleUnitConversion(climateDetails.co2)}kg CO<sub>2</sub>e
                    {isSimple && dot}
                </span>
            )}
            {shouldDisplay(climateDetails.water) && (
                <span className="climate-details__water">
                    <img src={`${iconPath}/droplet.svg`} alt="droplet icon" />
                    {handleUnitConversion(climateDetails.water)}l
                </span>
            )}
        </div>
    );
};

ClimateDetails.propTypes = {
    climateDetails: PropTypes.object.isRequired,
    itemQuantity: PropTypes.number,
    isSimple: PropTypes.bool,
};

export default ClimateDetails;
